/**
 * @what intercept all http requests to add a slash (all our servers require this) and add failure functions to respond to http error codes
 * @why general logging and event trapping of network communication
 */

import { ConfigurationProvider } from '../core/configuration';

interface ISGDNetworkConfig {
  logActivity: boolean;
  prependUrl: string;
  appendUrl: string;
  versionUrl: string;
  trailingSlash: boolean;
  defaultHTTPFields: DefaultHTTPFields;
  defaultHeaders?: ng.IHttpRequestConfigHeaders;
}

interface DefaultHTTPFields {
  timeout: number;
  xsrfHeaderName: string;
  xsrfCookieName: string;
  cache: boolean;
}

export class NetworkUrlConfigurationProvider implements ng.IServiceProvider {
  private configuration: ISGDNetworkConfig;
  private DEFAULTS: ISGDNetworkConfig = {
    logActivity: false,
    prependUrl: '',
    appendUrl: '',
    versionUrl: 'v',
    trailingSlash: false,
    defaultHTTPFields: {
      timeout: 10000,
      xsrfHeaderName: 'X-CSRFToken',
      xsrfCookieName: 'csrftoken',
      cache: false
    }
  };

  constructor(private $httpProvider: ng.IHttpProvider, private ConfigurationProvider: ConfigurationProvider) {}

  configure(userConfig: Partial<ISGDNetworkConfig>) {
    var existingConfiguration = this.configuration;

    if (!!userConfig) {
      this.configuration = _.merge({}, this.DEFAULTS, existingConfiguration, userConfig);
    }

    return this.configuration;
  }

  activate(userConfig: any) {
    var IS_FULL_URL = /^http/;
    var IS_RESOURCE_REQUEST = /\.\w{3,4}$/i;
    var HAS_QUERY_PARAMETERS = /\?/i;

    this.configure(userConfig);
    const configProvider = this.ConfigurationProvider;
    this.$httpProvider.interceptors.push(() => {
      return {
        request: (config) => {
          var newUrl;
          var parsedUrl;
          var versionAPI = configProvider.read('about').version.api;
          var configUrl = config.url;
          var isHTTPRequest = IS_FULL_URL.test(configUrl);
          var hasExtension = IS_RESOURCE_REQUEST.test(configUrl);
          var isAnAPIRequest = !hasExtension;
          var hasVersion = /v[0-9]+/.test(configUrl);

          if (isAnAPIRequest && !isHTTPRequest) {
            parsedUrl = configUrl.replace(/^\//, '').replace(/\/$/, '');

            newUrl = this.configuration.prependUrl;

            if (!!this.configuration.versionUrl && !hasVersion) {
              newUrl = newUrl + '/' + this.configuration.versionUrl + versionAPI;
            }

            newUrl = newUrl + '/' + parsedUrl + this.configuration.appendUrl;

            if (!HAS_QUERY_PARAMETERS.test(config.url) && !!this.configuration.trailingSlash) {
              newUrl = newUrl + '/';
            }

            config.url = newUrl;
          }

          if (isAnAPIRequest) {
            config = _.merge({}, this.configuration.defaultHTTPFields, config);
            config.headers = _.merge({}, this.configuration.defaultHeaders, config.headers);
            config.params = config.params || {};
          }

          return config;
        },

        response: function responseHTTPInterceptor(response) {
          return response;
        }
      };
    });

    return this.configuration;
  }

  read() {
    return this.configuration;
  }

  public $get() {
    return {
      configure: (userConfig: ISGDNetworkConfig) => {
        return this.configure(userConfig);
      },
      read: () => {
        return this.read();
      }
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-configuration/src/configuration/network_url_configuration.ts